import { render, staticRenderFns } from "./FormTypeIcon.vue?vue&type=template&id=05e127ca"
import script from "./FormTypeIcon.vue?vue&type=script&lang=js"
export * from "./FormTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports